import tw from 'tailwind-styled-components'
export const DataCard = tw.div`
flex
justify-between
border
rounded-lg
px-4 
py-4
`